// extracted by mini-css-extract-plugin
export default {"devices":"DeviceModels_devices__rzh05"};